<template>
  <v-card
    flat
    class="rounded-0 py-4 px-6 align-center"
    :class="{
      'no-background': !isNotResumePage,
      'resume-page-limit': !isNotResumePage,
    }"
  >
    <v-row align="center" no-gutters>
      <v-col
        cols="auto"
        class="d-flex align-center px-0 flex-grow-0 mr-2"
        style="width: 240px !important"
      >
        <v-icon
          v-if="isNotResumePage"
          class="arrow-left-icon mr-2"
          size="16"
          @click="handleBackToResume()"
        >
          mdi-arrow-left
        </v-icon>
        <span class="body-bold-small title" v-if="headerTitle">{{
          headerTitle
        }}</span>
        <span v-else class="body-bold-small title">Analytics</span>
      </v-col>

      <v-col class="d-flex justify-end align-center pa-0 px-0">
        <v-row no-gutters class="content-actions align-center">
          <div v-if="isNotResumePage" class="pickers-div">
            <VideosFilterPicker
              :label="$t('message.pages.analyticsV3.videosFilter.picker.label')"
              :data-step="1"
              :data-intro="`<strong>${$t(
                `message.pages.analyticsV3.tours.${
                  canViewTourInComparerPage ? 'compare' : 'plays'
                }.step1.title`
              )}</strong><br><br>${$t(
                `message.pages.analyticsV3.tours.${
                  canViewTourInComparerPage ? 'compare' : 'plays'
                }.step1.description`
              )}`"
            />
            <RangeDatePicker
              :shortcuts="shortcuts"
              :initial-range-date="initialRangeDate"
              :btn-text="$t('message.pages.analyticsV3.filter')"
              @fetch-range-date="fetchDate"
              :data-step="2"
              :data-intro="`<strong>${$t(
                `message.pages.analyticsV3.tours.${
                  canViewTourInComparerPage ? 'compare' : 'plays'
                }.step2.title`
              )}</strong><br><br>${$t(
                `message.pages.analyticsV3.tours.${
                  canViewTourInComparerPage ? 'compare' : 'plays'
                }.step2.description`
              )}`"
            />
          </div>

          <div
            class="container-picker-on-resule"
            v-if="isVisibleHeaderActions && !isNotResumePage"
            :style="{
              right: pickerPosition + 'px',
            }"
          >
            <RangeDatePicker
              :shortcuts="shortcuts"
              :initial-range-date="initialRangeDate"
              :btn-text="$t('message.pages.analyticsV3.filter')"
              @fetch-range-date="fetchDate"
            />
          </div>

          <div
            class="actions-div"
            :class="{ 'align-right-buttons': !isNotResumePage }"
          >
            <span class="d-flex items-center">
              <BaseIntroReset v-bind="{ click: onClickIntro }" />
            </span>

            <v-menu
              v-if="!isNotResumePage"
              offset-y
              v-model="isOpenMenu"
              transition="slide-y-transition"
              class="menu-analytics-v3"
            >
              <template v-slot:activator="{ on, attrs }">
                <base-btn
                  v-bind="attrs"
                  v-on="on"
                  class="mr-0 mt-2 mt-sm-0"
                  :data-step="2"
                  :data-intro="`<strong>${$t(
                    `message.pages.analyticsV3.tours.resume.step2.title`
                  )}</strong><br><br>${$t(
                    `message.pages.analyticsV3.tours.resume.step2.description`
                  )}`"
                >
                  {{ $t('message.pages.analyticsV3.resume.moreMetrics') }}
                  <v-icon size="20" class="ml-1">
                    {{ isOpenMenu ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                  </v-icon>
                </base-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="item in menuItems"
                  :key="item.name"
                  @click="handleClick(item.name)"
                  class="px-3"
                >
                  <v-list-item-title class="body-regular-smaller">
                    {{ item.label }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu
              v-if="isNotResumePage"
              offset-y
              v-model="isOpenMenu"
              transition="slide-y-transition"
              class="menu-analytics-v3"
            >
              <template v-slot:activator="{ on, attrs }">
                <base-btn
                  v-bind="attrs"
                  v-on="on"
                  class="mr-0 mt-2 mt-sm-0"
                  :data-step="canViewTourInComparerPage ? 5 : 4"
                  :data-intro="`<strong>${$t(
                    `message.pages.analyticsV3.tours.${
                      canViewTourInComparerPage ? 'compare' : 'plays'
                    }.step${canViewTourInComparerPage ? 5 : 4}.title`
                  )}</strong><br><br>${$t(
                    `message.pages.analyticsV3.tours.${
                      canViewTourInComparerPage ? 'compare' : 'plays'
                    }.step${canViewTourInComparerPage ? 5 : 4}.description`
                  )}`"
                >
                  {{ $t('message.pages.analyticsV3.export') }}
                  <v-icon size="20" class="ml-1">
                    {{ isOpenMenu ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                  </v-icon>
                </base-btn>
              </template>
              <v-list>
                <template v-for="item in exportOptions">
                  <v-tooltip
                    v-if="item.disabled"
                    :key="item.name + '-tooltip'"
                    right
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        v-on="on"
                        v-bind="attrs"
                        style="width: 100%; cursor: not-allowed"
                      >
                        <v-list-item :disabled="true" class="px-3">
                          <v-list-item-title class="body-regular-smaller">
                            {{ item.label }}
                          </v-list-item-title>
                        </v-list-item>
                      </div>
                    </template>
                    <span>{{
                      $t('message.pages.analyticsV3.exportDisabledTooltip')
                    }}</span>
                  </v-tooltip>

                  <v-list-item
                    v-else
                    :key="item.name"
                    :disabled="item.disabled"
                    @click.prevent="handleExport(item)"
                    class="px-3"
                  >
                    <v-list-item-title class="body-regular-smaller">
                      {{ item.label }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>
          </div>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog v-model="isConfirmModalOpen" max-width="500px" persistent>
      <v-card v-if="selectedExportOption" class="confirmation-dialog-card">
        
        <v-card-title
          class="body-bold-medium neutral-20-dark--text py-2"
          style="min-height: 72px; line-height: 120%"
        >
          {{ selectedExportOption.label }}
          <v-spacer></v-spacer>
          <v-btn icon @click="closeConfirmModal" :disabled="pdfState === 'loading'">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text
          class="py-8"
          style="min-height: 100px; display: flex; align-items: center"
        >
          <span
            v-if="pdfState === 'initial'"
            class="text-body-1 mb-0 neutral-20-dark--text"
            style="white-space: pre-line"
          >
            {{ this.$t('message.pages.analyticsV3.exportModalText') }}
            {{ this.$t('message.pages.analyticsV3.exportModalSubText') }}
            {{ selectedExportOption.name.toUpperCase() }}?
          </span>
          <div
            v-else-if="pdfState === 'ready'"
            class="text-body-1 mb-0 neutral-20-dark--text"
          >
            <span class="d-block">
              {{ $t('message.pages.analyticsV3.exportModalPdfGeneratedTitle') }}
            </span>
            
            <span class="d-block">
              {{ $t('message.pages.analyticsV3.exportModalPdfGeneratedSubtitle') }}
            </span>
          </div>
          <div
            v-else
            class="text-body-1 mb-0 neutral-20-dark--text"
          >
            <span class="d-block">
              {{ $t('message.pages.analyticsV3.exportModalPdfGeneratingTitle') }}
            </span>
            
            <span class="d-block">
              {{ $t('message.pages.analyticsV3.exportModalPdfGeneratingSubtitle') }}
            </span>
          </div>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions class="pa-4 dialog-actions-background" style="min-height: 88px">
            <v-spacer></v-spacer>
            <base-btn v-if="pdfState !== 'ready'" type="tertiary" @click="closeConfirmModal" :disabled="pdfState === 'loading'">
                {{ this.$t('message.pages.analyticsV3.exportModalCancelButton') }}
            </base-btn>
            <base-btn v-else type="tertiary" @click="closeConfirmModal" :disabled="pdfState === 'loading'">
                {{ this.$t('message.pages.analyticsV3.exportModalCloseButton') }}
            </base-btn>
            
            <base-btn v-if="pdfState === 'initial'" class="ml-4" type="primary" @click="confirmExport">
                {{ this.$t('message.pages.analyticsV3.exportModalConfirmButton') }}
                {{ selectedExportOption.name.toUpperCase() }}
            </base-btn>

            <v-btn
              v-else-if="pdfState === 'loading'"
              class="ml-4 loading-pdf-btn"  disabled
              style="height: 40px;"
            >
              <v-progress-circular
                indeterminate
                color="primary"  size="20"
                width="2"
                class="mr-2"
              ></v-progress-circular>
              <span class="body-regular-small">
                {{ $t('message.pages.analyticsV3.exportModalPdfGeneratingDownload')}}
              </span>
            </v-btn>
            
            <base-btn v-else-if="pdfState === 'ready'" class="ml-4" type="primary" @click="downloadAndClose">
                <v-icon size="18">
                  mdi-download
                </v-icon>
                {{ $t('message.pages.analyticsV3.exportModalPdfDownload')}}
            </base-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import RangeDatePicker from '@/components/RangeDatePicker'
import VideosFilterPicker from './VideosFilter/VideosFilterPicker.vue'
import { subDays } from 'date-fns'
import { mapMutations, mapState } from 'vuex'
import introMixin from '@/utils/intro.mixin.js'
import { downloadBlob } from '@/utils/pdfExporter.js'

export default {
  name: 'Header',
  components: {
    RangeDatePicker,
    VideosFilterPicker,
  },
  mixins: [introMixin],
  data() {
    return {
      isOpenMenu: false,
      isExportMenuOpen: false,
      isConfirmModalOpen: false,
      selectedExportOption: null,
      tourType: '',
      visibleHeaderActions: false,
      positionConfirm: false,
      disableIntro: false,
      pickerPosition: 0,
      header_title: null,
      pdfState: 'initial', 
      pdfBlob: null,
      pdfFilename: ''
    }
  },
  mounted() {
    this.handleTourType()
    this.$root.$on('pdf-ready', this.handlePdfReady)
    this.UPDATE_FILTER_VIDEOS({
      selectedVideos: null,
    })
    this.UPDATE_COMPARE_VIDEOS({
      selectedVideos: null,
    })
    this.$root.$emit('analyticsHeaderMounted')
    this.$root.$on('videosComparerMounted', this.handleVideosComparerMounted)
  },
  created() {
    this.$root.$on(
      'isVisibleDatePickerOnResume',
      this.handleVisibleHeaderActions
    )
    this.$root.$on(
      'updatePickerPositionOnResume',
      this.updatePickerPositionOnResume
    )
    this.$root.$on('updateHeaderTitle', (val) => {
      this.header_title = val
    })
  },
  beforeDestroy() {
    this.$root.$off('videosComparerMounted')
    this.$root.$off('isVisibleDatePickerOnResume')
    this.$root.$off('updatePickerPositionOnResume')
    this.$root.$off('pdf-ready', this.handlePdfReady)
  },
  methods: {
    ...mapMutations('analytics', [
      'UPDATE_FILTER_DATA_RANGE',
      'UPDATE_FILTER_VIDEOS',
      'UPDATE_COMPARE_VIDEOS',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),

    handleExport(item) {
      if (item.disabled) return
      this.selectedExportOption = item
      this.isConfirmModalOpen = true
      this.isExportMenuOpen = false
    },

    confirmExport() {
      if (!this.selectedExportOption) return

      switch (this.selectedExportOption.name) {
        case 'csv':
          this.exportCsv()
          this.closeConfirmModalBasic()
          break
        case 'png':
          this.exportPng()
          this.closeConfirmModalBasic()
          break
        case 'pdf':
          this.pdfState = 'loading'
          this.exportPdf()
          break
      }
      
    },

    closeConfirmModalBasic() {
      this.isConfirmModalOpen = false
      this.selectedExportOption = null
    },

    exportCsv() {
      this.$root.$emit('trigger-csv-export')
      this.isExportMenuOpen = false
    },

    exportPng() {
      this.$root.$emit('trigger-png-export')
      this.isExportMenuOpen = false
    },

    exportPdf() {
      this.$root.$emit('trigger-pdf-export')
      this.isExportMenuOpen = false
    },
    downloadAndClose() {
      try {
        if (this.pdfBlob && this.pdfFilename) {
          downloadBlob(this.pdfBlob, this.pdfFilename)
          this.UPDATE_GLOBAL_SNACKBAR({
            open: true,
            text: this.$t('message.pages.analyticsV3.exportModalPdfSuccess'), 
            type: 'success',
          })

        } else {
          throw new Error('Blob do PDF ou nome do arquivo não encontrado.')
        }
      } catch (error) {
        console.error('Erro ao tentar iniciar o download:', error)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: this.$t('message.pages.analyticsV3.exportModalPdfError'), 
          type: 'error',
        })
      } finally {
        this.closeConfirmModal()
      }
    },
    handlePdfReady({ blob, filename }) {
        if (this.isConfirmModalOpen && this.selectedExportOption.name === 'pdf') {
            this.pdfBlob = blob
            this.pdfFilename = filename
            this.pdfState = 'ready'
        }
    },
    closeConfirmModal() {
        this.isConfirmModalOpen = false
        setTimeout(() => {
            this.pdfState = 'initial'
            this.pdfBlob = null
            this.pdfFilename = ''
        }, 300)
    },

    handleClick(name) {
      this.isOpenMenu = false
      this.$router.push({ name })
    },

    fetchDate(event) {
      const [start, end] = event
      const updateFilterDataRange = {
        start,
        end,
      }

      this.UPDATE_FILTER_DATA_RANGE(updateFilterDataRange)
    },
    handleBackToResume() {
      this.$router.push({ name: 'AnalyticsV3Resume' })
    },
    handleTourType() {
      if (this.$route.name === 'AnalyticsV3Resume') {
        this.tourType = 'resume'
        return
      }

      if (this.$route.name === 'AnalyticsV3VideoComparer') {
        this.tourType = 'comparer'
        return
      }

      this.tourType = 'others'
    },
    handleVisibleHeaderActions(value) {
      if (!this.positionConfirm) {
        return
      }

      if (this.isNotResumePage) {
        this.visibleHeaderActions = true
        return
      }

      this.visibleHeaderActions = value
    },
    updatePickerPositionOnResume(value) {
      const docWidth = document.documentElement.clientWidth || window.innerWidth

      if (!this.positionConfirm) {
        this.positionConfirm = true
      }

      if (value.isMediumBreakpoint) {
        this.pickerPosition = 204
        return
      }

      this.pickerPosition = docWidth - value.value - 24
    },

    handleVideosComparerMounted() {
      this.tourType = 'comparer'
      this.disableIntro = false
      const introName = `analytics_v3_${this.tourType}`
      this.intro_key = introName
      this.setIntroJS({ key: introName, delay: 3500 })
    },
    onClickIntro() {
      if (this.disableIntro) {
        return
      }

      this.refreshIntro()
    },
  },
  computed: {
    ...mapState({
      userPlanInfo: (state) => state.user.userPlanInfo,
      dateRange: (state) => state.analytics.filters.dateRange,
      errorState: (state) => state.analytics.errorState,
    }),
    canViewTourInResumePage() {
      return (
        this.$route.name === 'AnalyticsV3Resume' && this.tourType === 'resume'
      )
    },
    canViewTourInComparerPage() {
      return (
        this.$route.name === 'AnalyticsV3VideoComparer' &&
        this.tourType === 'comparer'
      )
    },
    canViewTourInOthersPages() {
      return (
        !this.canViewTourInComparerPage &&
        !this.canViewTourInResumePage &&
        this.tourType === 'others'
      )
    },
    isNotResumePage() {
      return this.$route.name !== 'AnalyticsV3Resume'
    },
    isVisibleHeaderActions() {
      if (this.isNotResumePage) {
        return true
      }

      return this.visibleHeaderActions
    },
    exportOptions() {
      return [
        {
          name: 'png',
          label: this.$t('message.pages.analyticsV3.exportPng'),
          disabled: this.$route.name === 'AnalyticsV3Retention' || this.$route.name === 'AnalyticsV3VideoComparer',
          tooltip: this.$t('message.pages.analyticsV3.exportDisabledTooltip'),
        },
        {
          name: 'pdf',
          label: this.$t('message.pages.analyticsV3.exportPdf'),
          // disabled: true,
          // tooltip: this.$t('message.pages.analyticsV3.exportDisabledTooltip'),
        },
        {
          name: 'csv',
          label: this.$t('message.pages.analyticsV3.exportCsv'),
        },
      ]
    },
    menuItems() {
      return [
        {
          name: 'AnalyticsV3Plays',
          label: this.$t('message.pages.analyticsV3.plays'),
        },
        {
          name: 'AnalyticsV3Retention',
          label: this.$t('message.pages.analyticsV3.retention'),
        },
        {
          name: 'AnalyticsV3Devices',
          label: this.$t('message.pages.analyticsV3.devices'),
        },
        {
          name: 'AnalyticsV3Browsers',
          label: this.$t('message.pages.analyticsV3.browsers'),
        },
        {
          name: 'AnalyticsV3Locations',
          label: this.$t('message.pages.analyticsV3.locations'),
        },
        {
          name: 'AnalyticsV3Reference',
          label: this.$t('message.pages.analyticsV3.references'),
        },
        {
          name: 'AnalyticsV3Users',
          label: this.$t('message.pages.analyticsV3.users'),
          isNew: true,
        },
        {
          name: 'AnalyticsV3Bandwidth',
          label: this.$t('message.pages.analyticsV3.screen_bandwidth.title'),
          isNew: true,
        },
      ]
    },
    shortcuts() {
      const plan = this.userPlanInfo

      return [
        {
          text: this.$i18next.t(
            'message.pages.video.metricsPage.datepicker.yesterday'
          ),
          onClick() {
            const date = new Date()
            return [subDays(date, 1), subDays(date, 1)]
          },
        },
        {
          text: this.$i18next.t(
            'message.pages.analyticsV3.datapicker.currentCycle'
          ),

          onClick() {
            const startDate = new Date(
              plan.subscription.current_period_start * 1000
            )
            const endDate = new Date(
              plan.subscription.current_period_end * 1000
            )

            return [startDate, endDate]
          },
        },
        {
          text: this.$i18next.t(
            'message.pages.video.metricsPage.datepicker.7days'
          ),
          onClick() {
            const date = new Date()
            return [subDays(date, 7), date]
          },
        },
        {
          text: this.$i18next.t(
            'message.pages.video.metricsPage.datepicker.aMonth'
          ),
          onClick() {
            return [subDays(new Date(), 30), new Date()]
          },
        },
        {
          text: (() => {
            const now = new Date()
            const monthNames = [
              'january',
              'february',
              'march',
              'april',
              'may',
              'june',
              'july',
              'august',
              'september',
              'october',
              'november',
              'december',
            ]
            const lastMonthIndex =
              now.getMonth() - 1 < 0 ? 11 : now.getMonth() - 1
            const lastMonthName = monthNames[lastMonthIndex]
            return this.$i18next.t(`message.pages.credits.${lastMonthName}`)
          })(),
          onClick() {
            const now = new Date()
            const firstDayLastMonth = new Date(
              now.getFullYear(),
              now.getMonth() - 1,
              1
            )
            const lastDayLastMonth = new Date(
              now.getFullYear(),
              now.getMonth(),
              0
            )
            return [firstDayLastMonth, lastDayLastMonth]
          },
        },
      ]
    },
    initialRangeDate() {
      return [this.dateRange.start, this.dateRange.end]
    },
    dynamicOverlayColor() {
      return this.$vuetify.theme.dark
        ? 'rgba(255, 255, 255, 0.15)'
        : 'rgba(0, 0, 0, 0.6)'
    },
    headerTitle() {
      this.header_title
      return this.header_title
    },
  },
  watch: {
    $route() {
      this.handleTourType()
    },
    tourType(newValue) {
      const introName = `analytics_v3_${newValue}`
      this.intro_key = introName
      if (newValue === 'comparer') {
        this.disableIntro = true
        return
      }

      this.setIntroJS({ key: introName, delay: 3500 })
    },
  },
}
</script>

<style lang="scss" scoped>
.confirmation-dialog-card {
  font-family: 'Rubik', sans-serif;
}

.dialog-actions-background {
  background-color: varFigma(neutral-99);
}

.container {
  border-bottom: 1px solid varFigma(neutral-95-lightest);
}

.content-header {
  align-items: center;
}

.content-actions {
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  position: relative;
}

.pickers-div {
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: end;
  gap: 12px;
}
.actions-div {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
}

.title {
  color: varFigma(neutral-20-dark);
}

.icon {
  cursor: pointer;
  padding: 8px;
  color: varFigma(neutral-40-light);
  background-color: transparent !important;
}

.header-border {
  border-bottom: 1px solid varFigma(neutral-95-lightest);
}

.no-background {
  background-color: transparent !important;
  padding-left: 30px !important;
  border-bottom: none;
}

.arrow-left-icon {
  color: varFigma(neutral-40-light) !important;
}

.container-picker-on-resule {
  max-width: 375px;
  position: absolute;
}

.resume-page-limit {
  max-width: 1540px;
  margin-left: auto;
  margin-right: auto;
  padding: 29px 16px 16px 16px !important;
}

.align-right-buttons {
  position: fixed;
  right: 36px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 12px;
}

.loading-pdf-btn.v-btn--disabled {
  background-color: var(--neutral-90-light) !important;  
  text-transform: none !important;
  letter-spacing: normal !important;

  .body-regular-small {
    color: var(--neutral-70-light) !important;
  }
}
</style>
